// extracted by mini-css-extract-plugin
module.exports = {"button":"NoBorderButton_button__1fr6v","touch":"NoBorderButton_touch__1uNy7"};